export const evaluationItems: {
  title: string
  imgPath: string
  url: string
  profile: {
    date: string
    content: JSX.Element
  }[]
}[] = [
  {
    title: '厚生労働省',
    imgPath: '/images/ir-approval.png',
    url: 'https://jsite.mhlw.go.jp/fukuoka-roudoukyoku/content/contents/000393811.pdf',
    profile: [
      {
        date: 'えるぼし認定(３つ星)',
        content: (
          <>
            女性活躍推進法に基づき、一般事業主行動計画の策定・届出等を行った事業主のうち、女性の活躍推進に関する取組の実施状況が優良である等の一定の要件を満たした事業者が、都道府県労働局への申請により、厚生労働大臣の認定を受けることができる。当社グループは３つ星認定。
          </>
        )
      },
    ],
  },
  {
    title: '厚生労働省',
    imgPath: '/images/ir-certification.jpg',
    url: 'https://jsite.mhlw.go.jp/fukuoka-roudoukyoku/content/contents/001294466.pdf',
    profile: [
      {
        date: 'もにす認定',
        content: (
          <>
            障がい者雇用の促進及び安定に関する取組が優良な中小事業主を厚生労働大臣が認定する制度。当制度により、中小事業主全体で障がい者雇用の取組が進展することが期待される。当社グループの株式会社トライアルベネフィットが認定を受けた。
          </>
        )
      },
    ],
  },
  {
    title: '日興アイ・アール',
    imgPath: '/images/ir-winning.png',
    url: 'https://pdf.irpocket.com/C141A/PDLX/kjCI/VjBh.pdf',
    profile: [
      {
        date: '全上場企業ホームページ充実度ランキング',
        content: (
          <>
            日興アイ・アール株式会社が、全上場企業3,937社のホームページについて、「分かりやすさ」「使いやすさ」「情報の多さ」の3つの視点で設定した客観的な項目に基づいた評価を行い、ランキングとして公表したもの。
            <br />
            「グロース市場部門」においては、最優秀10社、優秀26社が選定された。 当社は、今回で２度目の選定となり、２年連続の受賞。
          </>
        )
      },
    ],
  },
  {
    title: '日本証券アナリスト協会',
    imgPath: '/images/ir-winning-2025.jpg',
    url: 'https://pdf.irpocket.com/C141A/w4ok/y4Wp/Cd9q.pdf',
    profile: [
      {
        date: '証券アナリストによるディスクロージャー優良企業選定 新興市場銘柄部門',
        content: (
          <>
            日本証券アナリスト協会が、企業の情報開示の促進および向上を目的として
            <br />
            1995 年より実施しているもの。
            <br />
            公益社団法人日本証券アナリスト協会が実施する2025年度「証券アナリストによるディスクロージャー優良企業選定」の新興市場銘柄部門において、優良企業に初めて選定。
          </>
        )
      },
    ],
  },
]
